<template>
  <VueFlow
    :nodes="nodes"
    :edges="edges"
    :elements-selectable="false"
    :nodes-draggable="false"
    :nodes-connectable="false"
    :node-types="{
      element: markRaw(ElementNode),
      figure: markRaw(FigureNode),
      root: markRaw(RootNode),
    }"
    :edge-types="{
      'elk-edge': markRaw(ElkEdge),
    }"
  >
    <slot />
  </VueFlow>
</template>

<script setup lang="ts">
import { VueFlow, type Edge, type Node } from "@vue-flow/core";
import { markRaw } from "vue";
import ElementNode from "./Nodes/ElementNode.vue";
import FigureNode from "./Nodes/FigureNode.vue";
import ElkEdge from "./ElkEdge.vue";
import RootNode from "./Nodes/RootNode.vue";

defineProps<{
  nodes: Node[];
  edges: Edge[];
}>();
</script>
